// import { useEffect, useState } from "react";

// const BeforeProjectContent = () => {
//   const COLORS = {
//     primaryGreen: "#5ec250",
//   };

//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const onResize = () => setIsMobile(window.innerWidth <= 768);
//     onResize();
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const styles = {
//     container: {
//       maxWidth: isMobile ? "100%" : "1100px",
//       margin: "0 auto",
//       padding: isMobile ? "40px 16px" : "60px 20px",
//       fontFamily: "Segoe UI, sans-serif",
//       textAlign: isMobile ? "center" : "",
//     },

//     title: {
//       textAlign: "center",
//       fontSize: "clamp(26px, 4vw, 44px)", // KEEP SAME
//       fontWeight: 500,
//       lineHeight: 1.2,
//       marginBottom: isMobile ? "30px" : "50px",
//     },

//     highlight: { color: COLORS.primaryGreen },

//     /* ================= SECTION 1 ================= */
//     sectionOne: {
//       display: "flex",
//       gap: "40px",
//       flexWrap: "wrap",
//       flexDirection: isMobile ? "column" : "row",
//     },

//     leftImageWrap: {
//       flex: "1 1 420px",
//       display: "flex",
//       justifyContent: "center",
//     },

//     imageStack: {
//       position: "relative",
//       width: "100%",
//       maxWidth: isMobile ? "300px" : "420px",
//     },

//     imageTiltShade: {
//       position: "absolute",
//       top: isMobile ? "8px" : "12px",
//       left: isMobile ? "15px" : "36px",
//       width: "100%",
//       height: isMobile ? "84%" : "100%",
//       background: "#e5e5e5",
//       borderRadius: "38px",
//       transform: isMobile ? "rotate(2deg)" : "rotate(5deg)",
//       zIndex: 0,
//     },

//     leftImage: {
//       position: "relative",
//       width: "100%",
//       borderRadius: "35px",
//       zIndex: 1,
//     },

//     rightContent: {
//       flex: "1 1 480px",
//       display: "flex",
//       flexDirection: "column",
//     },

//     description: {
//       fontSize: isMobile ? "16px" : "20px",
//       lineHeight: 1.8,
//       color: "#555",
//       marginBottom: "25px",
//     },

//     bottomRow: {
//       display: "flex",
//       gap: "20px",
//       marginTop: "auto",
//       flexDirection: isMobile ? "column" : "row",
//     },

//     highlightCard: {
//       flex: "1 1 160px",
//       background: "#3b3b3b",
//       color: "#fff",
//       padding: "20px",
//       borderRadius: "16px",
//       fontSize: isMobile ? "16px" : "18px",
//       lineHeight: 1.6,
//     },

//     smallImage: {
//       width: isMobile ? "100%" : "200px",
//       borderRadius: "16px",
//       objectFit: "cover",
//     },

//     /* ================= SECTION 2 ================= */
//     sectionTwo: {
//       display: "flex",
//       gap: "40px",
//       marginTop: "50px",
//       flexWrap: "wrap",
//       flexDirection: isMobile ? "column" : "row",
//     },

//     modernLeft: {
//       flex: "1 1 420px",
//       display: "flex",
//       flexDirection: "column",
//       gap: "18px",
//     },

//     modernTitle: {
//       fontSize: isMobile ? "22px" : "26px",
//       fontWeight: 500,
//       lineHeight: 1.3,
//     },

//     modernLeftCard: {
//       background: "#f1fbf4",
//       borderRadius: "22px",
//       padding: "18px",
//     },

//     modernImage: {
//       width: "100%",
//       borderRadius: "18px",
//       marginBottom: "14px",
//     },

//     modernCaption: {
//       fontSize: isMobile ? "16px" : "18px",
//       lineHeight: 1.6,
//       color: "#333",
//     },

//     modernRight: {
//       flex: "1 1 520px",
//       display: "flex",
//       flexDirection: "column",
//     },

//     modernDesc: {
//       fontSize: isMobile ? "16px" : "20px",
//       lineHeight: 1.7,
//       color: "#555",
//       marginBottom: "26px",
//     },

//     featureGrid: {
//       width: "100%",
//       alignSelf: isMobile ? "center" : "",
//       alignItems: "center",
//       display: "grid",
//       gridTemplateColumns: isMobile ? "repeat(2, 180px)" : "repeat(2, 280px)",
//       gap: isMobile ? "10px" : "20px",
//       marginBottom: "28px",
//       justifyContent: "center",
//     },

//     featureCard: {
//       border: "1px solid #eee",
//       borderRadius: "18px",
//       padding: "22px",
//       width: isMobile ? "120px" : "180px",
//       textAlign: "center",
//       background: "#fff",
//       fontSize: isMobile ? "16px" : "18px",
//     },

//     featureCardActive: {
//       background: COLORS.primaryGreen,
//       color: "#fff",
//       borderRadius: "18px",
//       padding: "22px",
//       width: isMobile ? "120px" : "180px",
//       textAlign: "center",
//       fontSize: isMobile ? "16px" : "18px",
//     },

//     featureGridWrapper: {
//       width: "100%",
//       overflowX: "hidden",
//       transform: isMobile ? "scale(0.85)" : "scale(1)",
//       transformOrigin: "top left",
//     },

//     featureIcon: {
//       width: "46px",
//       height: "46px",
//       borderRadius: "50%",
//       background: "#e9f8ee",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       margin: "0 auto 8px",
//     },

//     featureIconActive: {
//       background: "#fff",
//     },

//     iconImg: {
//       width: isMobile ? "32px" : "40px",
//       objectFit: "contain",
//     },

//     footerText: {
//       fontSize: isMobile ? "16px" : "20px",
//       lineHeight: 1.7,
//       color: "#555",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h1 style={styles.title}>
//         Discover Premium Apartments & Houses <br />
//         for Sale in Trichy with{" "}
//         <span style={styles.highlight}>Mitha Homes</span>
//       </h1>

//       {/* SECTION 1 */}
//       <div style={styles.sectionOne}>
//         <div style={styles.leftImageWrap}>
//           <div style={styles.imageStack}>
//             <div style={styles.imageTiltShade} />
//             <img
//               src="https://dev.mithahomes.com/backend/uploads/home/image2.png"
//               alt="Apartment"
//               style={styles.leftImage}
//             />
//           </div>
//         </div>

//         <div style={styles.rightContent}>
//           <p style={styles.description}>
//             At Mitha Homes, we bring you thoughtfully designed houses and
//             apartments for sale in Trichy at the city’s most sought-after
//             locations. With a strong focus on quality construction, transparent
//             dealings, and customer satisfaction, we help you find a home that
//             perfectly matches your lifestyle and long-term aspirations.
//           </p>

//           <div style={styles.bottomRow}>
//             <div style={styles.highlightCard}>
//               Whether you are searching for an apartment for sale in Trichy, a
//               premium flat, or a high-budget house below ₹3 crore, Mitha Homes
//               offers curated residential options that blend comfort, elegance,
//               and value.
//             </div>

//             <img
//               src="https://dev.mithahomes.com/backend/uploads/home/image3.png"
//               alt="Building"
//               style={styles.smallImage}
//             />
//           </div>
//         </div>
//       </div>

//       {/* SECTION 2 */}
//       <div style={styles.sectionTwo}>
//         <div style={styles.modernLeft}>
//           <h2 style={styles.modernTitle}>
//             Premium Apartments for Sale in Trichy –{" "}
//             <span style={{ color: COLORS.primaryGreen }}>
//               Designed for Modern Living
//             </span>
//           </h2>

//           <div style={styles.modernLeftCard}>
//             <img
//               src="https://dev.mithahomes.com/backend/uploads/home/image4.png"
//               alt="Apartment Project"
//               style={styles.modernImage}
//             />
//             <p style={styles.modernCaption}>
//               Our projects are strategically located to offer excellent
//               connectivity, peaceful surroundings, and access to essential city
//               conveniences.
//             </p>
//           </div>
//         </div>

//         <div style={styles.modernRight}>
//           <p style={styles.modernDesc}>
//             If you are planning to invest in an apartment sale in Trichy, Mitha
//             Homes presents a wide range of new flats for sale in Trichy,
//             tailored for both end-users and investors.
//           </p>

//           <div style={styles.featureGridWrapper}>
//             <div style={styles.featureGrid}>
//               {[
//                 ["apartment.svg", "2 BHK & 3 BHK flats for sale in Trichy"],
//                 ["diamond.svg", "Premium flats with superior specifications"],
//                 ["crown.svg", "Luxury apartments for discerning homeowners"],
//                 [
//                   "wallet.svg",
//                   "High-budget apartments with exclusive features",
//                 ],
//               ].map(([icon, text], i) => (
//                 <div
//                   key={i}
//                   style={
//                     i === 1 ? styles.featureCardActive : styles.featureCard
//                   }
//                 >
//                   <div
//                     style={
//                       i === 1
//                         ? { ...styles.featureIcon, ...styles.featureIconActive }
//                         : styles.featureIcon
//                     }
//                   >
//                     <img src={`/icons/${icon}`} alt="" style={styles.iconImg} />
//                   </div>
//                   {text}
//                 </div>
//               ))}
//             </div>
//           </div>

//           <p style={styles.footerText}>
//             Each apartment is carefully planned to maximize natural light,
//             ventilation, and space efficiency, ensuring a refined living
//             experience.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BeforeProjectContent;

import { useEffect, useState } from "react";

const BeforeProjectContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      overflowX: "hidden",
    },

    title: {
      textAlign: "center",
      fontSize: "clamp(26px, 4vw, 44px)",
      fontWeight: 500,
      lineHeight: 1.2,
      marginBottom: isMobile ? "30px" : "50px",
    },

    highlight: { color: COLORS.primaryGreen },

    /* ================= SECTION 1 ================= */
    sectionOne: {
      display: "flex",
      gap: "40px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    leftImageWrap: {
      flex: "1 1 420px",
      display: "flex",
      justifyContent: "center",
    },

    imageStack: {
      position: "relative",
      width: "100%",
      maxWidth: isMobile ? "280px" : "420px",
    },

    imageTiltShade: {
      position: "absolute",
      top: isMobile ? "8px" : "12px",
      left: isMobile ? "15px" : "36px",
      // top: "12px",
      // left: "18px",
      transform: isMobile ? "rotate(2deg)" : "rotate(5deg)",
      width: "100%",
      height: isMobile ? "84%" : "100%",
      background: "#e5e5e5",
      borderRadius: "38px",
      // transform: "rotate(4deg)",
      zIndex: 0,
    },

    leftImage: {
      position: "relative",
      width: "100%",
      borderRadius: "35px",
      zIndex: 1,
    },

    rightContent: {
      marginTop:isMobile?"-65px":"",
      flex: "1 1 480px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    description: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.8,
      color: "#555",
      marginBottom: "25px",
    },

    bottomRow: {
      display: "flex",
      gap: "20px",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    highlightCard: {
      background: "#3b3b3b",
      color: "#fff",
      padding: "20px",
      borderRadius: "16px",
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      width: isMobile ? "88%" : "100%",
    },

    smallImage: {
      width: isMobile ? "100%" : "200px",
      maxWidth: "320px",
      borderRadius: "16px",
      objectFit: "cover",
    },

    /* ================= SECTION 2 ================= */
    sectionTwo: {
      display: "flex",
      gap: "40px",
      marginTop: "50px",
      flexWrap: "wrap",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
    },

    modernLeft: {
      flex: "1 1 420px",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      textAlign: isMobile ? "center" : "left",
    },

    modernTitle: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
    },

    modernLeftCard: {
      background: "#f1fbf4",
      borderRadius: "22px",
      padding: "18px",
    },

    modernImage: {
      width: "100%",
      borderRadius: "18px",
      marginBottom: "14px",
    },

    modernCaption: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      color: "#333",
    },

    modernRight: {
      flex: "1 1 520px",
      display: "flex",
      flexDirection: "column",
      textAlign: isMobile ? "center" : "left",
    },

    modernDesc: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
      marginBottom: "26px",
    },

    featureGrid: {
      display: "grid",
      gridTemplateColumns: isMobile
        ? "repeat(auto-fit, minmax(140px, 1fr))"
        : "repeat(2, 1fr)",
      gap: "16px",
      justifyItems: "center",
      marginBottom: "28px",
    },

    featureCard: {
      border: "1px solid #eee",
      borderRadius: "18px",
      padding: "20px",
      width: "100%",
      maxWidth: isMobile ? "120px" : "180px",
      textAlign: "center",
      background: "#fff",
      fontSize: isMobile ? "15px" : "18px",
    },

    featureCardActive: {
      background: COLORS.primaryGreen,
      color: "#fff",
      borderRadius: "18px",
      padding: "20px",
      width: "100%",
      maxWidth: isMobile ? "120px" : "180px",
      textAlign: "center",
      fontSize: isMobile ? "15px" : "18px",
    },

    featureIcon: {
      width: "46px",
      height: "46px",
      borderRadius: "50%",
      background: "#e9f8ee",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 8px",
    },

    featureIconActive: {
      background: "#fff",
    },

    iconImg: {
      width: "36px",
      objectFit: "contain",
    },

    footerText: {
      fontSize: isMobile ? "16px" : "20px",
      lineHeight: 1.7,
      color: "#555",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Discover Premium Apartments & Houses <br />
        for Sale in Trichy with{" "}
        <span style={styles.highlight}>Mitha Homes</span>
      </h1>

      {/* SECTION 1 */}
      <div style={styles.sectionOne}>
        <div style={styles.leftImageWrap}>
          <div style={styles.imageStack}>
            <div style={styles.imageTiltShade} />
            <img
              src="https://dev.mithahomes.com/backend/uploads/home/image2.png"
              alt="Apartment"
              style={styles.leftImage}
            />
          </div>
        </div>

        <div style={styles.rightContent}>
          <p style={styles.description}>
            At Mitha Homes, we bring you thoughtfully designed houses and
            apartments for sale in Trichy at the city’s most sought-after
            locations. With a strong focus on quality construction, transparent
            dealings, and customer satisfaction, we help you find a home that
            perfectly matches your lifestyle and long-term aspirations.
          </p>

          <div style={styles.bottomRow}>
            <div style={styles.highlightCard}>
              Whether you are searching for an apartment for sale in Trichy, a
              premium flat, or a high-budget house below ₹3 crore, Mitha Homes
              offers curated residential options that blend comfort, elegance,
              and value.
            </div>

            <img
              src="https://dev.mithahomes.com/backend/uploads/home/image3.png"
              alt="Building"
              style={styles.smallImage}
            />
          </div>
        </div>
      </div>

      {/* SECTION 2 */}
      <div style={styles.sectionTwo}>
        <div style={styles.modernLeft}>
          <h2 style={styles.modernTitle}>
            Premium Apartments for Sale in Trichy –{" "}
            <span style={{ color: COLORS.primaryGreen }}>
              Designed for Modern Living
            </span>
          </h2>

          <div style={styles.modernLeftCard}>
            <img
              src="https://dev.mithahomes.com/backend/uploads/home/image4.png"
              alt="Apartment Project"
              style={styles.modernImage}
            />
            <p style={styles.modernCaption}>
              Our projects are strategically located to offer excellent
              connectivity, peaceful surroundings, and access to essential city
              conveniences.
            </p>
          </div>
        </div>

        <div style={styles.modernRight}>
          <p style={styles.modernDesc}>
            If you are planning to invest in an apartment sale in Trichy, Mitha
            Homes presents a wide range of new flats for sale in Trichy,
            tailored for both end-users and investors.
          </p>

          <div style={styles.featureGrid}>
            {[
              ["apartment.svg", "2 BHK & 3 BHK flats for sale in Trichy"],
              ["diamond.svg", "Premium flats with superior specifications"],
              ["crown.svg", "Luxury apartments for discerning homeowners"],
              ["wallet.svg", "High-budget apartments with exclusive features"],
            ].map(([icon, text], i) => (
              <div
                key={i}
                style={i === 1 ? styles.featureCardActive : styles.featureCard}
              >
                <div
                  style={
                    i === 1
                      ? { ...styles.featureIcon, ...styles.featureIconActive }
                      : styles.featureIcon
                  }
                >
                  <img src={`/icons/${icon}`} alt="" style={styles.iconImg} />
                </div>
                {text}
              </div>
            ))}
          </div>

          <p style={styles.footerText}>
            Each apartment is carefully planned to maximize natural light,
            ventilation, and space efficiency, ensuring a refined living
            experience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BeforeProjectContent;
